export const DEFAULT_ITEM_WIDTH = 264;
export const DEFAULT_STRIP_HEIGHT = 280;
export const TIER_STRIP_HEIGHT = 210;
